import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onJoin, onExplore }) {
  return (
    <section className="py-24 md:py-32 bg-brand-paper2 relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-brand-wine/[0.03] blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.1] text-brand-ink">
            Your next business opportunity <span className="italic text-brand-wine">could begin here</span>.
          </h2>
        </motion.div>

        <div className="mt-16 grid lg:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white rounded-[2rem] border border-brand-line p-8 md:p-10"
          >
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand-wine">
              For Businesses
            </span>
            <h3 className="mt-3 font-serif text-3xl font-medium text-brand-ink">
              Ready to grow your business?
            </h3>
            <p className="mt-3 text-brand-muted text-[15px] leading-relaxed">
              Become part of a trusted network of women-led businesses that are visible, procurement-ready, and connected to real market opportunities.
            </p>
            <button
              onClick={onJoin}
              className="mt-8 group inline-flex items-center gap-2 bg-brand-wine text-white rounded-lg pl-6 pr-5 py-3.5 font-medium text-[15px] hover:bg-brand-wineDark hover:-translate-y-0.5 transition-all"
              data-testid="final-join-cta"
            >
              Join the Business Exchange Today
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="bg-brand-ink text-brand-cream rounded-[2rem] p-8 md:p-10 relative overflow-hidden"
          >
            <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-brand-wine/30" />
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand-cream/70">
              For Buyers
            </span>
            <h3 className="mt-3 font-serif text-3xl font-medium">
              Looking to source?
            </h3>
            <p className="mt-3 text-brand-cream/80 text-[15px] leading-relaxed">
              Discover curated women-led businesses and professionals for products, services, procurement, and partnerships.
            </p>
            <button
              onClick={onExplore}
              className="mt-8 group inline-flex items-center gap-2 bg-brand-cream text-brand-ink rounded-lg pl-6 pr-5 py-3.5 font-medium text-[15px] hover:bg-white hover:-translate-y-0.5 transition-all"
              data-testid="final-explore-cta"
            >
              Explore the Business Exchange
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
